import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ResponseViewInventoryMove } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-update-move-inventory',
  templateUrl: './update-move-inventory.component.html',
  styleUrls: ['./update-move-inventory.component.css'],
})
export class UpdateMoveInventoryComponent implements OnInit, AfterViewInit {
  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
  @ViewChild('locations') locationsSelect: MatSelect
  FormularioConfirmar: FormGroup;
  datosJson:any;
  ArrayLocations = [];
  Error: String;
  locationInventory:any;
  constructor(
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private formbuider: FormBuilder,
    public dialogRef: MatDialogRef<UpdateMoveInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResponseViewInventoryMove
  ) {
    this.ArrayLocations = [];
   
  }
  ngAfterViewInit(): void {
  
  }
  ngOnInit(): void {
    this.FormularioConfirmar = this.formbuider.group({
      Quantity: [''],
      location: ['']
    });
    this.OnChangeData();
    
  }
  OnChangeData() {
    console.log(this.data);
try {
  this.locationInventory=JSON.parse(this.data.Location)
  this.ArrayLocations=this.locationInventory
  this.FormularioConfirmar.controls.location.setValue(Number(this.locationInventory[0].id))
} catch (error) {
  
}
    
    this.FormularioConfirmar.controls.Quantity.setValue(String(this.data.Quantity));
  }
  OnSelectLocations(search:any) {
   
    var ss=String(search)

    if (ss=='') {
      
    
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
        
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response;
        //this.OnChangeData();
      });
    } else {
      if (ss.length>3) {
        this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
        
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response;
        this.locationsSelect.open();
       // this.OnChangeData();
      });
      } else {
        
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  OnConfirmar() {
    if(Number(this.FormularioConfirmar.controls.Quantity.value)>Number(this.data.Quantity)){
      return;
    }
    var Request = {};
    var ids=this.data.id.split("|")
    Request["id"]=Number(ids[0]);
    Request["tblLocationID"]= Number(this.FormularioConfirmar.controls.location.value);
    Request["Quantity"]=String(this.FormularioConfirmar.controls.Quantity.value);
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/UpdateReceivingMoveinventory`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        if (response.responses == 'success') {
          this.Toast.fire({
            icon: 'success',
            title: 'Success',
          });
          this.onNoClick();
        } else {
          this.Error = response.responses;
          this.Toast.fire({
            icon: 'error',
            title:  response.responses,
          });
        }
      });
  }
  filterDataCustomerSearchOrder(locationName: string) {
    return this.ArrayLocations.filter((object) => {
      if (object['location'] == locationName) {
        return object;
      }
    });
  }
  applyFilterLocation (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
  
this.OnSelectLocations(filterValue.trim().toLowerCase())
   
  }
}
